import { InputMasks } from 'common/fields/input-field';
import * as Yup from 'yup';

export const model = {
  value: {
    name: 'value',
    inputType: 'input',
    placeholder: 'RTP value, %',
    mask: InputMasks.floatNumber,
  },
  screenshot: {
    name: 'screenshot',
    type: 'file',
    placeholder: 'Screenshot proof...',
  },
};

export const validationSchema = Yup.object().shape({
  [model.value.name]: Yup.string().required('Required').min(0).max(100),
});

export const initialValues = {
  slot: '',
  [model.value.name]: '',
  [model.screenshot.name]: null,
};
